import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AddCustomerDTO, CustomerPaginationDTO, EditCustomerDTO } from "../../dtos/batch";
import customerHistoryService from "./customerHistoryService";

const initialState = {
    customerHistoryDetails: [],
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: <any>"",

    isCustomerLoading: false,
    isCustomerSuccess: false,
    customerMessage:<any>"",
    isCustomerError: false,

    ispaymentLoading: false,
    isPaymentSuccess: false,
    paymentMessage:<any>"",
    isPaymentError: false,

    isInvoiceLoading: false,
    isInvoiceSuccess: false,
    invoiceMessage:<any>"",
    isInvoiceError: false,
    allInvoices: [],

    receive: false


}

export const getCustomerHistory = createAsyncThunk(
    "getCustomerHistory", // Action type prefix
    async (
      { pharmacy_id, dto }: { pharmacy_id: any; dto?: CustomerPaginationDTO},
      thunkAPI
    ) => {
      try {
        const response = await customerHistoryService.getCustomerHistory(
          pharmacy_id,
          dto
        ); // Call the function
        return response.data;
      } catch (error: any) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );
export const getAllInvoices = createAsyncThunk(
    "getAllInvoices", // Action type prefix
    async (
      { pharmacy_id, customer_id }: { pharmacy_id: any; customer_id: any},
      thunkAPI
    ) => {
      try {
        const response = await customerHistoryService.getAllInvoices(
          pharmacy_id,
          customer_id
        ); // Call the function
        return response.data;
      } catch (error: any) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  export const editCustomer = createAsyncThunk(
    "customer/edit",
    async (customer: EditCustomerDTO , thunkAPI) => {
      try {
        return await customerHistoryService.editedCustomer(customer);
      } catch (error: any) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );
  

  export const addCustomerPayment = createAsyncThunk(
    "payment/add",
    async (payment: AddCustomerDTO , thunkAPI) => {
      try {
        return await customerHistoryService.addCustomerPayment(payment);
      } catch (error: any) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );



export const customerHistorySlice = createSlice({
    name: "customerHistorySlice",
    initialState,
    reducers: {
      reset: () => initialState,
      changeReceive: (state, action) => {
        state.receive = action.payload;
      },
    },
  
    extraReducers: (builder) => {
      builder
        .addCase(getCustomerHistory.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(getCustomerHistory.fulfilled, (state, action) => {
          state.isLoading = false;
          state.isSuccess = true;
          state.customerHistoryDetails = action.payload;
          state.message = "";
        })
        .addCase(getCustomerHistory.rejected, (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
        }).addCase(editCustomer.pending, (state) => {
          state.isCustomerLoading = true;
        })
        .addCase(editCustomer.fulfilled, (state, action) => {
          state.isCustomerLoading = false;
          state.isCustomerSuccess = true;
          // state.customerHistoryDetails = action.payload;
          state.customerMessage = "";
        })
        .addCase(editCustomer.rejected, (state, action) => {
          state.isCustomerLoading = false;
          state.isCustomerError = true;
          state.customerMessage = action.payload;
        })
        .addCase(addCustomerPayment.pending, (state) => {
          state.ispaymentLoading = true;
        })
        .addCase(addCustomerPayment.fulfilled, (state, action) => {
          state.ispaymentLoading = false;
          state.isPaymentSuccess = true;
          // state.customerHistoryDetails = action.payload;
          state.paymentMessage = "";
        })
        .addCase(addCustomerPayment.rejected, (state, action) => {
          state.ispaymentLoading = false;
          state.isPaymentError = true;
          state.paymentMessage = action.payload;
        })
        .addCase(getAllInvoices.pending, (state) => {
          state.isInvoiceLoading = true;
        })
        .addCase(getAllInvoices.fulfilled, (state, action) => {
          state.isInvoiceLoading = false;
          state.isInvoiceSuccess = true;
          state.allInvoices  = action.payload;
          state.invoiceMessage = "";
        })
        .addCase(getAllInvoices.rejected, (state, action) => {
          state.isInvoiceLoading = false;
          state.isInvoiceError = true;
          state.invoiceMessage = action.payload;
        })
    },
  });
  
  // Export actions and reducer
  export const { reset , changeReceive} = customerHistorySlice.actions;
  export default customerHistorySlice.reducer;